import { render, staticRenderFns } from "./Manifest_components.vue?vue&type=template&id=dc8ff618&scoped=true&"
import script from "./Manifest_components.vue?vue&type=script&lang=js&"
export * from "./Manifest_components.vue?vue&type=script&lang=js&"
import style0 from "./Manifest_components.vue?vue&type=style&index=0&id=dc8ff618&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc8ff618",
  null
  
)

export default component.exports